import {useMutation, gql} from '@apollo/client'

const MUTATE_EDIT_USER = gql`
  mutation MUTATE_EDIT_USER(
    $firstName: Customname
    $lastName: Customname
    $emailId: Email!
    $startDate: Date
    $endDate: Date
    $isTemporary: Boolean
    $rowId: Int
  ) {
    updatedUserDetails(
      firstName: $firstName
      lastName: $lastName
      emailId: $emailId
      startDate: $startDate
      endDate: $endDate
      isTemporary: $isTemporary
      rowId: $rowId
    ) {
      updateUser {
        first_name
        last_name
        email_id
        start_date
        end_date
        is_temporary
      }
    }
  }
`

export function useEditUser() {
  return useMutation(MUTATE_EDIT_USER, {
    context: {clientName: 'adminPanel'}
  })
}
